"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Base = exports.FontFamilyValues = void 0;

var BaseStyles = _interopRequireWildcard(require("./generated/base-styles"));

var DefaultStyles = _interopRequireWildcard(require("./generated/default-styles"));

var _constants = require("./constants");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = _interopRequireDefault(require("../colors"));

var _mediaQueries = require("../mediaQueries");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _generateTextComponent = _interopRequireDefault(require("./generateTextComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        hyphens: auto;\n        word-wrap: break-word;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    font-size: ", "px;\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", "px;\n    letter-spacing: ", "ch;\n    text-transform: ", ";\n    color: ", ";\n    text-align: ", ";\n    margin: 0;\n    padding: 0;\n    display: ", ";\n    font-variant-ligatures: no-common-ligatures;\n    ", ";\n    ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FontFamilyValues = {
  SansSerif: "\n    ".concat(_constants.fontFamily, "\n  "),
  Serif: "\n    DD-SourceSerifPro,\n    Georgia,\n    ".concat(_constants.fontFamily, "\n  ") // Only fallback to the overflow prop of styles
  // if the prop passed is undefined

};
exports.FontFamilyValues = FontFamilyValues;

var overflowIsTypeForSizeGroup = function overflowIsTypeForSizeGroup(sizeGroup) {
  return function (props, type) {
    return props.overflow === type || props.overflow === undefined && props[sizeGroup].overflow === type;
  };
}; // We can set letterSpacing to 0.0,
// so we need to check on that condition before
// falling back to the styles letterSpacing value


var getLetterSpacingForSizeGroup = function getLetterSpacingForSizeGroup(sizeGroup) {
  return function (props) {
    return props.letterSpacing || props.letterSpacing === 0.0 || props[sizeGroup].letterSpacing;
  };
}; // We round our lineHeights to the nearest 4pt
// multiple—ensures that our vertical rhythm is
// more consistent paired with our spacing values


var MULTIPLE_TO_ROUND_TO = 2;

var getLineHeightForSizeGroup = function getLineHeightForSizeGroup(sizeGroup) {
  return function (props) {
    return Math.round(MULTIPLE_TO_ROUND_TO * Math.round((props.size || props[sizeGroup].size) * (props.lineHeight || props[sizeGroup].lineHeight) / MULTIPLE_TO_ROUND_TO));
  };
};

var getOverrideOrStyleForSizeGroup = function getOverrideOrStyleForSizeGroup(sizeGroup) {
  return function (property) {
    return function (props) {
      return props[property] || props[sizeGroup][property];
    };
  };
};
/**
 * getStylesForSizeGroup
 *  Defines a CSS fragment with typography styles
 *  based on the set needed for the media query.
 *
 * @argument sizeGroup:
 * Defines what group of styles in props to generate
 * a CSS fragment with.
 */


var getStylesForSizeGroup = function getStylesForSizeGroup(sizeGroup) {
  var getOverrideOrStyle = getOverrideOrStyleForSizeGroup(sizeGroup);
  var getLineHeight = getLineHeightForSizeGroup(sizeGroup);
  var getLetterSpacing = getLetterSpacingForSizeGroup(sizeGroup);
  var overflowIsType = overflowIsTypeForSizeGroup(sizeGroup);
  return (0, _styledComponents.css)(_templateObject(), getOverrideOrStyle('size'), function (props) {
    return FontFamilyValues[getOverrideOrStyle('family')(props)];
  }, getOverrideOrStyle('weight'), getLineHeight, getLetterSpacing, getOverrideOrStyle('textTransform'), getOverrideOrStyle('color'), getOverrideOrStyle('textAlign'), function (props) {
    return props.display;
  }, function (props) {
    return overflowIsType(props, _constants.Overflows.BreakWord) && (0, _styledComponents.css)(_templateObject2());
  }, function (props) {
    return overflowIsType(props, _constants.Overflows.Truncate) && (0, _styledComponents.css)(_templateObject3(), props.maxLines > 1 && "\n            display: -webkit-box;\n            -webkit-line-clamp: ".concat(props.maxLines, ";\n            -webkit-box-orient: vertical;\n            max-height: ").concat(getLineHeight(props) * props.maxLines, "px;\n            white-space: normal;\n          "));
  });
};

var BaseText = _styledComponents.default.span(_templateObject4(), getStylesForSizeGroup('styles'), function (props) {
  return props.wideScreenStyles && _mediaQueries.Media.WideScreen(_templateObject5(), getStylesForSizeGroup('wideScreenStyles'));
}, function (props) {
  return props.desktopStyles && _mediaQueries.Media.Desktop(_templateObject6(), getStylesForSizeGroup('desktopStyles'));
}, function (props) {
  return props.tabletStyles && _mediaQueries.Media.Tablet(_templateObject7(), getStylesForSizeGroup('tabletStyles'));
}, function (props) {
  return props.mobileStyles && _mediaQueries.Media.Mobile(_templateObject8(), getStylesForSizeGroup('mobileStyles'));
});

BaseText.DisplayModes = _constants.DisplayModes;
BaseText.Sizes = _constants.Sizes;
BaseText.Styles = _objectSpread({}, BaseStyles, DefaultStyles);
BaseText.Weights = _constants.Weights;
BaseText.Families = _constants.FontFamilies;
BaseText.LineHeights = _constants.LineHeights;
BaseText.LetterSpacings = _constants.LetterSpacings;
BaseText.TextTransforms = _constants.TextTransforms;
BaseText.TextAlignments = _constants.TextAlignments;
BaseText.Overflows = _constants.Overflows;
BaseText.Colors = _objectSpread({}, _colors.default, {
  CurrentColor: 'currentColor'
});

var SizeProp = _propTypes.default.oneOf(Object.values(_constants.Sizes));

var FamilyProp = _propTypes.default.oneOf(Object.values(_constants.FontFamilies));

var WeightProp = _propTypes.default.oneOf(Object.values(_constants.Weights));

var LineHeightProp = _propTypes.default.oneOf(Object.values(_constants.LineHeights));

var LetterSpacingProp = _propTypes.default.oneOf(Object.values(_constants.LetterSpacings));

var TextTransformProp = _propTypes.default.oneOf(Object.values(_constants.TextTransforms));

var ColorProp = _propTypes.default.oneOf(Object.values(BaseText.Colors));

var TextAlignProp = _propTypes.default.oneOf(Object.values(_constants.TextAlignments));

var OverflowProp = _propTypes.default.oneOf(Object.values(_constants.Overflows));

var StylesProp = _propTypes.default.shape({
  size: SizeProp,
  family: FamilyProp,
  weight: WeightProp,
  lineHeight: LineHeightProp,
  letterSpacing: LetterSpacingProp,
  textTransform: TextTransformProp,
  color: ColorProp
});

BaseText.propTypes = {
  size: SizeProp,
  family: FamilyProp,
  weight: WeightProp,
  lineHeight: LineHeightProp,
  letterSpacing: LetterSpacingProp,
  textTransform: TextTransformProp,
  textAlign: TextAlignProp,
  overflow: OverflowProp,
  color: ColorProp,
  styles: StylesProp,
  wideScreenStyles: StylesProp,
  desktopStyles: StylesProp,
  tabletStyles: StylesProp,
  mobileStyles: StylesProp,
  maxLines: _propTypes.default.number,
  display: _propTypes.default.oneOf(Object.values(_constants.DisplayModes))
};
BaseText.defaultProps = {
  display: _constants.DisplayModes.Block,
  styles: BaseText.Styles.Medium16
};
var Base = (0, _generateTextComponent.default)(BaseText, []);
exports.Base = Base;
Base.propTypes = BaseText.propTypes;
Base.defaultProps = BaseText.defaultProps;
Base.DisplayModes = BaseText.DisplayModes;
Base.Sizes = BaseText.Sizes;
Base.Styles = BaseText.Styles;
Base.Weights = BaseText.Weights;
Base.Families = BaseText.Families;
Base.LineHeights = BaseText.LineHeights;
Base.LetterSpacings = BaseText.LetterSpacings;
Base.TextTransforms = BaseText.TextTransforms;
Base.TextAlignments = BaseText.TextAlignments;
Base.Overflows = BaseText.Overflows;
Base.Colors = BaseText.Colors;